module.exports = __webpack_public_path__ + "static/img/0010-3未启用吉林市人民政府.8933976.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/0010-3未启用吉林市人民政府.jpg
// module id = 3IYI
// module chunks = 0